import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigurationManagementService } from '../../../service/configuration-management.service';
import { LanguageManagementService } from '../../../service/language-management.service';
import { AccessInitialization, ActiveInactiveFor, KeyValues10, LocalService, PageKey, Status, TriggeredEvent } from '../../../service/local.service';
import { ProfileManagementService } from '../../../service/profile-management.service';
import { AddAccessComponent } from '../../popups/add-access/add-access.component';

@Component({
  selector: 'app-my-access',
  templateUrl: './my-access.component.html',
  styleUrls: ['./my-access.component.scss']
})
export class MyAccessComponent implements OnInit {
  lstSectionConfigKeys: string[] = ["access"]; ctryCode: string = ''; userId: string = ''; maxBodyHeight = 0;
  wrappers: KeyValues10[]; source: AccessInitialization; isShowActive = true; isShowInActive = false;
  constructor(public localService: LocalService, private cdr: ChangeDetectorRef, private languageManagementService: LanguageManagementService, private modalService: NgbModal, private profileManagementService: ProfileManagementService, private route: ActivatedRoute, private configurationManagementService: ConfigurationManagementService) { }

  ngOnInit(): void {
    this.languageManagementService.ensureLanguageSectionKeys(this.lstSectionConfigKeys);
    this.configurationManagementService.ensurePageActions(PageKey.MyAccess);
    this.route.params.subscribe(routeParams => {
      this.localService.saveUrl();
      this.localService.setBasicParams(routeParams.ctryCode, routeParams.userId, routeParams.interactionType);
      this.ctryCode = routeParams.ctryCode;
      this.userId = routeParams.userId;
      this.onLoad();
    });
  }

  ngAfterViewChecked() {
    this.maxBodyHeight = this.localService.onGetCustomBodyHeight(30);
    this.cdr.detectChanges();
  }

  onLoad(isInitiate = false) {
    if (!this.source || isInitiate) {
      this.profileManagementService.getAccessInitialization(this.userId, this.ctryCode).subscribe(result => {
        this.source = result;        
        this.onFilter();
      });
    } else {
      this.profileManagementService.getUserAccess(this.userId, this.ctryCode).subscribe(result => {
        this.source.content = result;        
        this.onFilter();
      });
    }
  }

  onFilter() {
    if (this.isShowActive && this.isShowInActive) {
      this.wrappers = this.source.content;
    } else if (this.isShowActive) {
      this.wrappers = this.source.content.filter(x => x.v3 == '1');
    } else if (this.isShowInActive) {
      this.wrappers = this.source.content.filter(x => x.v3 == '0');
    } else {
      this.wrappers = [];
    }
  }

  public getText(index: number, id: string) {
    let rtn = '';
    switch (index) {
      case 1: {
        let item = this.source.accessTypes.find(x => x.key == id);
        rtn = item != undefined ? item.value : '-';
      } break;
      case 2: {
        let item = this.source.accessRanges.find(x => x.key == id);
        rtn = item != undefined ? item.value : '-';
      } break;
    }
    return rtn;

  }

  onOpenAddAccess() {
    const modalRef = this.modalService.open(AddAccessComponent);
    modalRef.componentInstance.accessTypes = this.source.accessTypes;
    modalRef.componentInstance.accessRanges = this.source.accessRanges;
    modalRef.componentInstance.ctryCode = this.ctryCode;
    modalRef.componentInstance.userId = this.userId;
    modalRef.result.then((result) => {
      if (result.event == TriggeredEvent.Ok) {
        this.onLoad();
      }
    });
  }

  onActiveInactiveStatus(strId: string) {
    this.profileManagementService.activeInactiveStatus(strId, ActiveInactiveFor.Access).subscribe(result => {
      if (result.status == Status.Success) {
        const updatedItem = this.wrappers.find(x => x.key == strId);
        updatedItem.v3 = '0';
      }      
    });
  }
}
